(function () {
  if (window.__fbpDakiHeadAddonUpsellLoaded) return;
  window.__fbpDakiHeadAddonUpsellLoaded = true;

  var mapCache = {};
  var presentmentCache = {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function activeCurrency() {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return currency || 'USD';
  }

  /**
   * Derives the shop's rendered money shape from a sample the snippet formatted in Liquid
   * ({{ 1234567.89 | money }}), so this box matches the rest of the page character for
   * character - "€1.234,50" in the EU market, "$1,234.50" in the US one.
   */
  function parseMoneyShape(sample) {
    var match = String(sample || '').match(/^([^\d]*)([\d][\d.,\s]*[\d])([^\d]*)$/);
    if (!match) return null;
    // A money format carrying markup (some currency apps wrap the amount in a span) would be
    // inserted here as literal text. Fall back to Intl rather than print tags at the customer.
    if (/[<>]/.test(match[1] + match[3])) return null;
    var digits = match[2].replace(/\s/g, '');
    var lastDot = digits.lastIndexOf('.');
    var lastComma = digits.lastIndexOf(',');
    var lastSeparator = Math.max(lastDot, lastComma);
    if (lastSeparator < 0) {
      return { prefix: match[1], suffix: match[3], decimal: '', group: '', decimals: 0 };
    }
    var decimal = lastDot > lastComma ? '.' : ',';
    // A separator followed by anything other than two digits is a thousands separator, which
    // means this market renders whole units only.
    if (digits.length - lastSeparator - 1 !== 2) {
      return { prefix: match[1], suffix: match[3], decimal: '', group: decimal, decimals: 0 };
    }
    return {
      prefix: match[1],
      suffix: match[3],
      decimal: decimal,
      group: decimal === '.' ? ',' : '.',
      decimals: 2
    };
  }

  function money(cents, shape) {
    var value = Number(cents || 0) / 100;
    if (shape) {
      var fixed = shape.decimals === 2 ? value.toFixed(2) : String(Math.round(value));
      var parts = fixed.split('.');
      var whole = parts[0];
      if (shape.group) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, shape.group);
      return shape.prefix + whole + (shape.decimals === 2 ? shape.decimal + parts[1] : '') + shape.suffix;
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency()
      }).format(value);
    } catch (error) {
      return activeCurrency() + ' ' + value.toFixed(2);
    }
  }

  /**
   * The add-on map is built once, in the shop currency. A visitor in another market is charged
   * Shopify's own market price, which is NOT the shop price times the exchange rate (Markets
   * applies its own rounding). So the real presentment prices are read from the product itself.
   */
  function loadPresentmentPrices(handle) {
    if (!handle) return Promise.resolve(null);
    if (!presentmentCache[handle]) {
      presentmentCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Head pillow presentment prices failed to load.');
          return response.json();
        })
        .then(function (product) {
          var prices = {};
          (product.variants || []).forEach(function (variant) {
            prices[String(variant.id)] = variant.price;
          });
          return prices;
        })
        .catch(function (error) {
          console.error(error);
          return null;
        });
    }
    return presentmentCache[handle];
  }

  // Net unit price actually charged in this market, or null when it cannot be established.
  function netPrice(addon, variant) {
    if (!variant) return null;
    if (addon.presentmentPrices) {
      var presentment = addon.presentmentPrices[String(variant.id)];
      if (typeof presentment === 'number') return presentment;
    }
    // Fall back to the map's own figure only when it is denominated in the currency on screen.
    if (addon.mapCurrency && addon.mapCurrency === activeCurrency()) return variant.price;
    return null;
  }

  function discountedFrom(net, percent) {
    return Math.round(net * (1 - (percent / 100)));
  }

  function withVat(amount) {
    var vat = window.FBP_EU_VAT;
    if (!vat || !vat.rate) return amount;
    return Math.round(amount * (1 + vat.rate));
  }

  function vatNoteText() {
    var vat = window.FBP_EU_VAT;
    if (!vat || !vat.rate) return '';
    var percent = vat.rate * 100;
    return 'incl. ' + percent.toFixed(percent % 1 ? 1 : 0) + '% ' + vat.label;
  }

  function imageUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function loadMap(url) {
    if (!url) return Promise.resolve(null);
    if (!mapCache[url]) {
      mapCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Head pillow add-on map failed to load.');
          return response.json();
        })
        .catch(function (error) {
          console.error(error);
          return null;
        });
    }
    return mapCache[url];
  }

  function selectedVariant(addon) {
    var select = addon.node.querySelector('[data-fbp-daki-addon-size]');
    var variantId = select ? select.value : '';
    return addon.product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || addon.product.variants.find(function (variant) {
      return variant.available;
    }) || addon.product.variants[0] || null;
  }

  function selectedDesignValue() {
    var checked = document.querySelector('input[name="Design"]:checked');
    return checked ? checked.value : '';
  }

  function artKeyFromDesign(design) {
    var value = String(design || '').toLowerCase();
    if (value.indexOf('female') >= 0) return 'female';
    if (value.indexOf('male') >= 0) return 'male';
    return '';
  }

  function selectedArtChoice(addon) {
    var choices = addon.product && addon.product.artChoices;
    if (!choices) return null;
    var key = artKeyFromDesign(selectedDesignValue());
    return choices[key] || choices.default || null;
  }

  function artImageForVariant(artChoice, variant, product) {
    var sizeText = String((variant && (variant.size || variant.title)) || '').toLowerCase();
    var imageSet = artChoice && artChoice.images;
    if (imageSet) {
      if (sizeText.indexOf('standard') >= 0 && imageSet.standard) return imageSet.standard;
      if (imageSet.square) return imageSet.square;
    }
    return (variant && variant.image) || (product && product.image) || {};
  }

  function updateAddon(addon) {
    var variant = selectedVariant(addon);
    if (!variant) return;

    var artChoice = selectedArtChoice(addon);
    var image = artImageForVariant(artChoice, variant, addon.product);
    var imageNode = addon.node.querySelector('[data-fbp-daki-addon-image]');
    var titleNode = addon.node.querySelector('[data-fbp-daki-addon-title]');
    var priceNode = addon.node.querySelector('[data-fbp-daki-addon-price]');
    var compareNode = addon.node.querySelector('[data-fbp-daki-addon-compare]');
    var discountedNode = addon.node.querySelector('[data-fbp-daki-addon-discounted]');
    var taxNode = addon.node.querySelector('[data-fbp-daki-addon-tax]');

    if (titleNode) titleNode.textContent = (artChoice && artChoice.title) || addon.product.title;
    if (imageNode) {
      imageNode.src = imageUrl(image.url, 180);
      imageNode.alt = image.alt || (artChoice && artChoice.title) || addon.product.title;
    }

    var net = netPrice(addon, variant);
    // Both figures are shown on the same basis. Showing one tax-inclusive price beside one
    // tax-free price is what made this box unreadable, so if either cannot be established
    // honestly, no price is shown at all.
    if (net === null) {
      if (priceNode) priceNode.hidden = true;
      return;
    }
    if (priceNode) priceNode.hidden = false;
    if (compareNode) compareNode.textContent = money(withVat(net), addon.moneyShape);
    if (discountedNode) {
      discountedNode.textContent = money(withVat(discountedFrom(net, addon.discountPercent)), addon.moneyShape);
    }
    if (taxNode) {
      var note = vatNoteText();
      taxNode.textContent = note;
      taxNode.hidden = !note;
    }
    updateSizeLabels(addon);
  }

  // Keeps the dropdown on the same currency and tax basis as the price beside it.
  function updateSizeLabels(addon) {
    var select = addon.node.querySelector('[data-fbp-daki-addon-size]');
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      var variant = addon.product.variants.find(function (candidate) {
        return String(candidate.id) === String(option.value);
      });
      if (!variant) return;
      var label = variant.size || variant.title;
      var net = netPrice(addon, variant);
      option.textContent = net === null
        ? label
        : label + ' - ' + money(withVat(discountedFrom(net, addon.discountPercent)), addon.moneyShape);
    });
  }

  function setError(form, message) {
    var owner = form && form.closest('cart-action');
    if (owner && typeof owner.stHandErrorTxt === 'function') {
      owner.stHandErrorTxt(message || false);
      return;
    }
    var wrapper = owner && owner.querySelector('.pr-form-error');
    var text = owner && owner.querySelector('.pr-form-error-text');
    if (wrapper && text) {
      wrapper.toggleAttribute('hidden', !message);
      if (message) text.textContent = message;
    }
  }

  function setLoading(form, loading) {
    var owner = form && form.closest('cart-action');
    var button = owner && owner.querySelector('[type="submit"]');
    var loader = owner && owner.querySelector('.ajax-loader');
    if (button) {
      button.classList.toggle('loading', loading);
      if (loading) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    }
    if (loader) loader.classList.toggle('hidden', !loading);
  }

  function formProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = String(key).match(/^properties\[(.+)\]$/);
      if (!match || value === '') return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function customChoiceIsChecked(form) {
    return Boolean(form && form.querySelector('input[name="Design"][value="Custom Choice"]:checked'));
  }

  function syncCustomChoice(form) {
    var sync = window.FBP_CUSTOM_CHOICE_SYNC_FORM;
    if (typeof sync === 'function') {
      return sync(form) || { ok: true };
    }
    if (!customChoiceIsChecked(form)) return { ok: true };
    return {
      ok: false,
      message: 'Custom Choice is still loading. Please try again in a moment.'
    };
  }

  function addItems(addon, form) {
    var formData = new FormData(form);
    var currentVariantId = String(formData.get('id') || '').trim();
    var quantity = Math.max(1, Number(formData.get('quantity') || 1));
    var headVariant = selectedVariant(addon);
    var artChoice = selectedArtChoice(addon);
    var headImage = artImageForVariant(artChoice, headVariant, addon.product);
    if (!currentVariantId || !headVariant || !headVariant.id) {
      return Promise.reject(new Error('The selected add-on is not available.'));
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('ajax-cart');
    var sections = cart && typeof cart.fetchSecToInclude === 'function'
      ? cart.fetchSecToInclude().map(function (section) { return section.id; })
      : [];

    var parentProperties = formProperties(formData);
    var addonProperties = {
      '_fbp_addon_type': 'matching-head-pillow',
      '_fbp_addon_parent_handle': addon.dakiHandle,
      '_fbp_addon_parent_title': addon.dakiTitle,
      '_fbp_addon_discount_percent': '30',
      'Add-on for': addon.dakiTitle,
      'Head pillow size': headVariant.size || headVariant.title
    };
    if (artChoice && artChoice.label) {
      addonProperties['Head pillow art'] = artChoice.label;
      addonProperties['_fbp_head_pillow_art'] = artChoice.label;
    }
    if (headImage && headImage.url) {
      addonProperties['_fbp_head_pillow_image'] = headImage.url;
      addonProperties['_fbp_head_pillow_image_alt'] = headImage.alt || (artChoice && artChoice.title) || addon.product.title;
    }

    var payload = {
      items: [
        {
          id: Number(currentVariantId),
          quantity: quantity,
          properties: parentProperties
        },
        {
          id: Number(headVariant.id),
          quantity: quantity,
          properties: addonProperties
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    return fetch(window.routes && window.routes.increase_cart_url ? window.routes.increase_cart_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.status) {
        throw new Error(response.description || 'Unable to add the add-on.');
      }
      if (cart) {
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        if (typeof cart.renderContents === 'function') cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else if (window.routes && window.routes.cart_url) {
        window.location = window.routes.cart_url;
      }
      if (typeof window.live === 'function' && window.SP_OBJECT) {
        window.live(window.SP_OBJECT.ajxcartRefresh, { source: 'daki-head-addon' });
      }
      return response;
    });
  }

  function attachSubmit(addon) {
    var form = document.querySelector('form[action*="/cart/add"]:has(button[name="add"])')
      || document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.fbpDakiHeadAddonSubmit === 'true') return;
    form.dataset.fbpDakiHeadAddonSubmit = 'true';
    var addPending = false;

    form.addEventListener('submit', function (event) {
      // Keep the same form locked even if the add-on is unchecked mid-request.
      if (addPending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      var toggle = addon.node.querySelector('[data-fbp-daki-addon-toggle]');
      if (!toggle || !toggle.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

      var syncResult = syncCustomChoice(form);
      if (!syncResult.ok) {
        setError(form, syncResult.message || 'Please finish your Custom Choice selection.');
        return;
      }

      setError(form, '');
      addPending = true;
      setLoading(form, true);
      var request;
      try {
        request = addItems(addon, form);
      } catch (error) {
        request = Promise.reject(error);
      }
      Promise.resolve(request)
        .catch(function (error) {
          console.error(error);
          setError(form, error.message || 'Unable to add the matching head pillow.');
        })
        .finally(function () {
          addPending = false;
          setLoading(form, false);
        });
    }, true);
  }

  function initNode(node) {
    var dakiHandle = node.getAttribute('data-product-handle');
    var dakiTitle = node.getAttribute('data-product-title') || 'this dakimakura';
    var mapUrl = node.getAttribute('data-map-url');
    if (!dakiHandle || !mapUrl) return;

    loadMap(mapUrl).then(function (map) {
      var product = map && map.productsByDakiHandle && map.productsByDakiHandle[dakiHandle];
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

      var availableVariants = product.variants.filter(function (variant) { return variant.available; });
      if (!availableVariants.length) return;

      return loadPresentmentPrices(product.handle).then(function (presentmentPrices) {
        var addon = {
          node: node,
          product: product,
          dakiHandle: dakiHandle,
          dakiTitle: dakiTitle,
          presentmentPrices: presentmentPrices,
          mapCurrency: map.currency || null,
          discountPercent: Number(map.discountPercent) || 30,
          moneyShape: parseMoneyShape(node.getAttribute('data-money-sample'))
        };

        var title = node.querySelector('[data-fbp-daki-addon-title]');
        var link = node.querySelector('[data-fbp-daki-addon-link]');
        var select = node.querySelector('[data-fbp-daki-addon-size]');
        if (title) title.textContent = product.title;
        if (link) link.href = product.url;
        if (select) {
          select.innerHTML = '';
          availableVariants.forEach(function (variant) {
            var option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.size || variant.title;   // priced by updateSizeLabels
            select.appendChild(option);
          });
          var defaultOption = availableVariants.find(function (variant) {
            return String(variant.size || '').toLowerCase() === '40x40cm';
          }) || availableVariants[0];
          select.value = defaultOption.id;
          select.addEventListener('change', function () {
            updateAddon(addon);
          });
        }

        document.querySelectorAll('input[name="Design"]').forEach(function (input) {
          input.addEventListener('change', function () {
            updateAddon(addon);
          });
        });
        // The VAT script is deferred later in the document than this one, so the first render can
        // land before the visitor's rate is known. Re-render once it is.
        document.addEventListener('fbp:vat-ready', function () { updateAddon(addon); });

        node.hidden = false;
        updateAddon(addon);
        attachSubmit(addon);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-fbp-daki-addon]').forEach(initNode);
  });
})();
